import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTapStyle0 = cosmosIconCss;

const CosmosIconTap$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTap extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e807bcd3c438ba84add973b8b3db2b1b67b1e71d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '11a28a0f5c33bd3581293ab054eab651921f6511', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8e98b764f5639dc174d879cc6d74ac8d06c2e739', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.111 8.933 14.082 9h-1.71a3.501 3.501 0 0 0-4.225-5.228A3.5 3.5 0 0 0 6 7.03c0 .732.227 1.41.613 1.97H4.902A4.94 4.94 0 0 1 4.5 7.043a5 5 0 1 1 9.611 1.89Zm-7.23 4.068c-1.249.029-2.866.517-2.381 2.499.133.546.59 2.339 1 2.5l2.042 1.5c.098.04.339.33.6.643.342.41.72.864.858.857h.5v-1.5c-.255-.462-.684-.972-1.134-1.256l-1.874-1.377a4.897 4.897 0 0 1-.176-.455 16.186 16.186 0 0 1-.36-1.268 1.33 1.33 0 0 1-.044-.323.36.36 0 0 1 .009-.087.224.224 0 0 1 .026-.02c.058-.042.18-.101.388-.148.047-.01.097-.02.147-.027.066.11.142.248.226.414.325.642.65 1.454.892 2.085l2.9-.538c0-.423-.11-1.09-.223-1.723-.106-.59-.244-1.294-.388-2.026l-.07-.364c-.346-1.768-.69-3.581-.782-4.685a.433.433 0 0 1 .417-.469c.128-.004.208.001.255.007a2.867 2.867 0 0 1 .229.622l1.357 5.52 1.048.11c1.183.124 2.073.578 3.36 1.44-.026 1.824-.055 2.775-.192 3.454-.086.426-.233.734-.511 1.114V21c.142.004.791-.06.878-.172 1.225-1.426 1.275-2.325 1.325-5.904.001-.077.005-.149.008-.217.015-.31.025-.532-.211-.707-1.557-1.073-2.78-1.819-4.5-2l-1.108-4.508C11 6 10.429 5.702 9.406 5.734a1.933 1.933 0 0 0-1.864 2.093c.086 1.038.369 2.598.663 4.121.07.369.143.736.213 1.092.31 1.588.582 2.974.582 3.46-.486-1.266-1.39-3.5-2-3.5h-.119Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTapStyle0; }
}, [1, "cosmos-icon-tap", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-tap"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-tap":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTap$1);
            }
            break;
    } });
}

const CosmosIconTap = CosmosIconTap$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTap, defineCustomElement };
